import { render, staticRenderFns } from "./Type1c.vue?vue&type=template&id=1b878e77&"
import script from "./Type1c.vue?vue&type=script&lang=js&"
export * from "./Type1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports